import { styled } from '@mui/system'
import { Grid, Box, Paper, Typography } from '@mui/material'
import { MEDIA, thinScrollbar } from '../../constants'

export const Wrapper = styled(Grid)(`
    display:flex;
`)

export const ListLink = styled('a')(`
    font-style: normal;
    font-weight: 400; // 300;
    font-size: 12px;
    line-height: 15px;
    padding: 10px 0;
    margin-right: 12px;
`)

export const Heading = styled(Typography)(`
    font-style: normal;
    font-weight: 600; // 500;
    font-size: 14px;
    position: relative;
`)

export const LhsMenuWrapper = styled(Box)(`
    padding:15px 20px;
    background: #F7F7F9;
    box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.08);
    min-width:240px;
    width:240px;
    display:flex;
    flex-direction:column;
    & li {
        padding:0;
    }
`)

export const ContentOuterWrapper = styled(Box)(`
    width:calc(100vw - 350px);
    height:calc(100vh - 200px);
    display:flex;
    flex-direction:column;
    overflow-y:auto;
`)

export const ContentInnerWrapper = styled(Box)(`
    width:100%;
    display:flex;
    position:relative;
    padding:20px 20px 0 20px;
    transition: all 1.5s; // FullScreening

    &.active {outline: 2px red solid;}

    &.visiblePageSection:first-of-type {
        .stickySidebarStatic:before { display:none !important; }
        .stickySidebarStatic { transform:translateY(-5px) !important; }
    }

    &.lastPageSection {
        padding-bottom: 20px;
    }

    &.isPPTModalActive, &.isPPTModalActive *{
        font-family:Verdana !important;
    }

    &.isPPTModalActive .loadingWrapper {
        display:none !important;
        position:fixed;
        top:100px;
        left:calc(100vw - 600px);
        z-index:2000;
        width:280px;
        height:50px;
        padding-left:30px !important;
        padding-top:5px !important;
        background:#fff;
        display:flex;
        justify-content:flex-start;
        &:after {
            content:'Preparing Report';
            height:40px;
            padding: 5px 0 0 10px !important;
            display:block;
            text-align:left;
            font-size:13px;
        }
        & img{
            width:24px !important;
            height:24px !important;
        }
    }

    &.onlyOneComponent {
        // min-height: calc(100vh - 190px); // THIS IS CREATING PROBLEM
        align-items: baseline;
    }

    &.askIaDetailPage {
        padding-top: 45px;
        z-index: 51;
        position: fixed;
        top: 0 !important;
        left: 240px;
        bottom: 0;
        right: 0;
        width: calc(100vw - 240px);
        background: #fff;
        padding: 0 8px 0 32px;
        flex-direction: column;
        border-radius: 20px 0 0 0;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.16);
        opacity: 1;
        transition: all 0s; // FullScreening
        animation: slideInFromRight 0.4s ease-out !important;
        & .moveInsightsToRight, .moveInsightsToLeft {
            overflow-y: auto important;
            overflow-x: hidden;
        }
        
        & td {
            border-bottom: none !important;
        }
    }
    
    @keyframes slideInFromRight {
        from {
            transform: translateX(100%);
        }
        to {
            transform: translateX(0);
        }
    }

    & .dynamicDriverWrapper > .DriversTr {border-bottom: 1px solid rgb(247, 247, 247); display: flex; width:100%; }
    & .dynamicDriverWrapper > .DriversTr * {box-shadow:none; }
    & .dynamicDriverWrapper > .DriversTr td {padding-top:2px; padding-bottom:2px; }
    & .dynamicDriverWrapper > .DriversTr > .DriversTr {padding:0; width:100%; }
    & .dynamicDriverWrapper .DriversTr button{display:none !important; }
    
    // & .dynamicDriverWrapper .snapshotRow, & .DriversTr .snapshotRow {
    //     border: 1px red solid;
    //     width: 100%;
    //     position: relative;
    //     display: grid;
    //     grid-auto-flow: dense;
    //     grid-template-columns: repeat(4, auto);
    // }

    @media (max-width: ${MEDIA.lg}) {
        &:after{
            width:calc(100% - 40px);
            left:20px;
        }
    }

    &.Competitive-landScape-Wrapper:has(.sliderOn) {
      // padding-right : 0;

      .row-arrow-icons {
        // margin-right : 20px;
      }
    }

`)

export const ContentWrapper = styled(Box)(
  (props) => `
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    min-width: 850px;
     
    &.isPPTModalActiveFalse {
    // ${
      !props?.is_ppt_modal_active &&
      `
        &.moveInsightsToRight > .reportHeading { order: 1; }
        &.moveInsightsToRight > .insightsOuterWrapper { order: 3; }
        &.moveInsightsToRight > .reportOuterWrapper { order: 2; }

        &.moveInsightsToRight > .reportHeading { }
        &.moveInsightsToRight > .insightsOuterWrapper { max-width: 1px;}
        // &.moveInsightsToRight > .insightsOuterWrapper .InsightsInnerWrapper{ display:none; border:1px red solid;}
        &.moveInsightsToRight > .insightsOuterWrapper .btnShow{ display:block; transform:rotate(0deg); margin-right:-8px; margin-top:-3px;}
        &.moveInsightsToRight.hideRhsInsights > .reportOuterWrapper { max-width:calc(100% - 20px); }
        
        &.moveInsightsToRight .btnHide { display:none !important; }
        &.moveInsightsToRight.showRhsInsights .btnHide { display:block !important; }

        &.moveInsightsToRight.showRhsInsights > .reportHeading { }
        // &.moveInsightsToRight.showRhsInsights > .InsightsInnerWrapper { }
        &.moveInsightsToRight.showRhsInsights > .insightsOuterWrapper { max-width: 300px;}
        &.moveInsightsToRight.showRhsInsights > .insightsOuterWrapper .InsightsInnerWrapper{ display:flex; }
        &.moveInsightsToRight.showRhsInsights > .insightsOuterWrapper .btnShow{ display:none;}
        &.moveInsightsToRight.showRhsInsights > .reportOuterWrapper { max-width:calc(100% - 300px); }

        &.moveInsightsToRight .ready {
            // outline: 1px #f1f1f1 solid;
        }
        &.moveInsightsToRight .stickySidebarDefault {
            height: fit-content;
            position: sticky;
            top: 0;
        }
        &.moveInsightsToRight .stickySidebarStatic {
            height: fit-content;
            position: sticky;
            top: 0;
            // transform: translateY(-15px); // creating issue this is the ideal solution when sticked
        }
        &.moveInsightsToRight .stickySidebar {
            height: fit-content;
            position: sticky;
            top: 0;
        }
        &.moveInsightsToRight .stickySidebar.fixed {
            position: fixed;
            top: 119px; //59px;
            right: 35px;
            background: #fff;
            z-index: 2; 
            &:before { display: none; }           
        }
        &.moveInsightsToRight .stickySidebar.bottom {
            bottom: 0;
            right: 20px;
            position: absolute;
        }
    // `
    }
    }


    @media (max-width: 980px) {
        min-width: 100%;
    }
`
)

export const LhsWrapper = styled(Box)(`
    width: calc(100% - 420px);
    padding:20px 30px;
`)

export const RhsWrapper = styled(Box)(`
    padding:20px 30px;
    min-width:420px;
    width:420px;
    display: flex;
    flex-direction:column;
`)

export const CardWrapper = styled(Box)(`
    display:flex;
    flex-wrap:wrap;
    justify-content:space-between;
    & > div:nth-of-type(1) {width:calc(50% - 15px)}
    & > div:nth-of-type(2) {width:calc(50% - 15px)}
`)

export const DeveloperWrapper = styled(Box)(
  (props) => `
    background: rgb(31, 31, 31, 0.9);
    font-size: 12px;
    border-radius: 5px;
    margin-bottom: 5px;
    padding: 4px;
    display: ${props?.show ? 'flex' : 'none'};
    & div {
        display: inline-block;
        padding: 0 10px;
    }
    & span {
        color: #fff;
    }
    & b {
        color: rgb(187, 134, 252);
        padding-right: 5px;
    }
`
)

export const PptLoadingStatus = styled(Box)(`
    position: fixed;
    bottom: 10px;
    left: 10px;
    z-index: 2000;
    background: #000;
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    display: none;
    max-height: 95vh;
    overflow: auto;
    font-size: 12px;
    min-width: 320px;
    & ol {
        margin-left: 13px;
        max-height: calc(90vh - 100px);
        overflow: auto;
        padding-right: 10px;
        list-style-position: inside;
        list-style-type: decimal;
    }
`)

export const CsvLoadingStatus = styled(Box)(`
    position: fixed;
    bottom: 10px;
    left: 10px;
    z-index: 2000;
    background: #000;
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    display: none;
    max-height: 95vh;
    overflow: auto;
    font-size: 12px;
    min-width: 320px;
    & ol {
        margin-left: 13px;
        max-height: calc(90vh - 100px);
        overflow: auto;
        padding-right: 10px;
        list-style-position: inside;
        list-style-type: decimal;
    }
`)

export const TabWrapper = styled(Box)(`
    display: flex;
    flex-wrap: wrap;
    padding: 16px 20px;
    position: relative;
    top: 0;
    background: #fff;
    z-index: 11;
    transition: all 0.3s ease;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.10);

    &.active {
        position: sticky;
        top: -45px;
    }

    &.first-tab, &.first-tab.active {
        top: 0;
        & h4{
            display: none;
        }       
    }

    & .dynamicTourText span {
      margin-top: 17px;
    }

`)


export const TabMainWrapper = styled(Box)(`
    position: relative;
`)

export const TabItem = styled('a')(`
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    text-decoration: none;
    margin-right: 12px;
    &:hover {
        text-decoration: none;
        color: #0066DB;
    }
    &.active {
        border-bottom-color: #0066DB;
        color: #0066DB;
    }
`)

export const TabTitle = styled('h4')(`
    width:100%;
    display: inline-block;
    font-size: 19px;
    font-weight: 400;
    color: #333;
    transition: all 0.3s ease;
    padding-bottom: 15px;
`)

export const AskAIDetailHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: 'calc(100% + 40px)',
  background: '#5B92D3',
  borderRadius: '20px 0 0 0',
  height: '36px',
  paddingLeft: '32px',
  left: '-32px',
  right: '-8px',
  marginBottom: '16px',
  position: 'relative',
  '& .phase-year': {
    fontSize: '16px',
    fontWeight: 500,
    color: '#fff',
  },
  '& .closeIcon': {
    background: '#095BBD80',
    borderRadius: 0,
    width: '36px',
    height: '36px',
    '&:hover': {
      background: '#095BBD80',
    },
  },
}))

export const SnapshotDetailHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: 'calc(100% + 40px)',
  background: '#5B92D3',
  borderRadius: '20px 0 0 0',
  height: '36px',
  paddingLeft: '32px',
  left: '-32px',
  right: '-8px',
  marginBottom: '16px',
  position: 'relative',
  '& .phase-year': {
    fontSize: '16px',
    fontWeight: 500,
    color: '#fff',
  },
  '& .closeIcon': {
    background: '#095BBD80',
    borderRadius: 0,
    width: '36px',
    height: '36px',
    '&:hover': {
      background: '#095BBD80',
    },
  },
}))

export const AskIaLayoutOuterWrapper = styled(Paper)`
  height: 100%;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  overflow-y: scroll;
  background: transparent;
  scroll-behavior: smooth;
  padding: 20px 20px 20px 20px;

  & > .reportOuterWrapper {
    margin-left: -8px;
    margin-top: -8px;
  }

  & .reportHeading {
    width: calc(100% - -7px);
  }

  & .reportHeading .headingRte {
    font-size: 19px;
    font-weight: 500;
  }

  ${thinScrollbar.styles}
`;

// export const AskIaLayoutOuterWrapper = styled(Paper)(({ theme }) => ({
//   // NOTE: IN THE WRAPPER <AskIaLayout/> respective css is also written ..
//   height: '100%',
//   borderRadius: '24px',
//   display: 'flex',
//   flexDirection: 'column',
//   width: '100%',
//   position: 'relative',
//   overflowY: 'scroll',
//   background: 'transparent',
//   scrollBehavior: 'smooth',
//   padding: '20px 20px 20px 20px',

//   '& > .reportOuterWrapper' : {
//     marginLeft: '-8px',
//     marginTop: '-8px',
//   },

//   '& .reportHeading' : {
//     width: 'calc(100% - -7px)'
//   },
//   '& .reportHeading .headingRte' : {
//     fontSize: '19px',
//     fontWeight: 500
//   },
  
//   // border: '1px red solid',
//   '&::scrollbar-button, &::-webkit-scrollbar-button': {
//     display: 'none',
//   },
//   '&::scrollbar, &::-webkit-scrollbar': {
//     width: '8px',
//   },
//   '&::scrollbar-track, &::-webkit-scrollbar-track': {
//     // backgroundColor: '#f0f0f0',
//     backgroundColor: 'transparent',
//     borderRadius: '4px',
//   },
//   '&::scrollbar-thumb, &::-webkit-scrollbar-thumb': {
//     backgroundColor: '#888',
//     borderRadius: '4px',
//     border: '2px solid #f0f0f0',
//   },
//   '&::scrollbar-thumb:hover, &::-webkit-scrollbar-thumb:hover': {
//     backgroundColor: '#555',
//   },
//   scrollbarWidth: 'thin',
//   scrollbarColor: '#888 #f0f0f0',
  
// }))

export const ReportPageLoader = styled(Box)(`
    position: fixed;
    top:0;
    left:0;
    z-index: 1000;
    width: 100vw;
    height: 100vh;
    background: rgba(255, 255, 255, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;

    display:none;

    & .loadingWrapper {
        transform: scale(2);
    }
`)
